// PluginContract_LegalSectionNode.ts
export const LegalSectionContract = {
  pluginName: 'LegalSectionPlugin',
  nodeTypes: ['LegalSectionNode'],
  register: (editor: any) => {
    editor.registerNodeType?.('LegalSectionNode');
    console.log('🔌 [LegalSectionPlugin] Registered LegalSectionNode');
  },
};